export default "__VITE_ASSET__nNq1xj8R__"